import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';
import {phoneBottomBarSx} from 'src/components/mobile/mobileDesign.sx';

/**
 * The bar itself.
 *
 * The column count is the number of items the viewer may actually open rather than a fixed five: an
 * item whose page their permissions do not allow is not rendered at all, and the ones that remain
 * share the row evenly instead of leaving a gap where it was.
 */
export const bottomNavSx = (items: number): SxProps<Theme> => ({
    ...(phoneBottomBarSx as object),
    gridTemplateColumns: `repeat(${items}, minmax(0, 1fr))`,
    // A desktop has the drawer standing open beside the page; this is the phone's and the tablet's
    // only permanent navigation, and it must never appear beside the drawer.
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
});
